// -------------- Dev Consts --------------
export const isDev: boolean = import.meta.env.VITE_APP_ENV === "dev"
export const isUat: boolean = import.meta.env.VITE_APP_ENV === "uat"
export const isProd: boolean = import.meta.env.VITE_APP_ENV === "prod"

// -------------- Feature Flags --------------
// Positive-list inclusion — any env not named here defaults OFF.
// `develop` branch deploys to UAT (VITE_APP_ENV=uat); `main` covers prod/sandbox/demo.
export const isPlanRecommendationsEnabledForEnvironment = (environment: string): boolean =>
  environment === "dev" || environment === "uat"
export const isPlanRecommendationsEnabled: boolean = isPlanRecommendationsEnabledForEnvironment(
  import.meta.env.VITE_APP_ENV
)
export const serverUrl: string = import.meta.env.VITE_APP_SERVER_URL
export const smartyKey: string = import.meta.env.VITE_APP_SMARTY_KEY
export const freshpaintToken: string = import.meta.env.VITE_APP_FRESHPAINT_TOKEN
export const freshpaintScriptUrl: string = "/js/freshpaint.v1.3.0.js"
export const moovFacilitatorAccountId: string = import.meta.env.VITE_APP_MOOV_FACILITATOR_ACCOUNT_ID
export const intercomAppId: string = import.meta.env.VITE_APP_INTERCOM_APP_ID
export const intercomMessengerEnvironment: string = import.meta.env.VITE_APP_INTERCOM_MESSENGER_ENVIRONMENT ?? ""

export const sentryUrl = "https://72a04703c05e4c889dea0d433607788c@o675910.ingest.sentry.io/4504475985379328"

// -------------- Links --------------

export const MOBILE_APP_DOWNLOAD_LINK = "https://onelink.to/vitableapp"
export const MARKETING_SITE_URL = "https://vitablehealth.com"
export const COVERED_PHARMACIES_LIST = "https://providers.vitablehealth.com/assets/ventegra_nationwide_network.pdf"

export const LABCORP_LAB_LOCATOR_LINK = "https://www.labcorp.com/patients/labs-and-appointments"
export const LABCORP_DRUG_AND_ALCOHOL_LAB_LOCATOR_LINK = "https://www.labcorpsolutions.com/ots/locator.do"
export const GETLABS_SCHEDULING_LINK = "https://app.getlabs.com/vitablehealth"
export const QUEST_LAB_LOCATOR_LINK = "https://appointment.questdiagnostics.com/find-location/as-location-finder"
export const CVS_MINUTE_CLINIC_LOCATOR_LINK = "https://www.cvs.com/minuteclinic/clinic-locator/"

// -------------- Email & Phone --------------
export const VITABLE_SUPPORT_EMAIL = "support@vitablehealth.com"
export const VITABLE_SUPPORT_PHONE = "4844160769"
export const VITABLE_SUCCESS_EMAIL = "success@vitablehealth.com"
